<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="divcenter">
          <div id="divTopRoleBased" *ngIf="topIconHide=='true'">
            <h4 class="colorgreen">{{modelItem.RoleUpdateMsg}}</h4>
          </div>
          <div class="col divBox" id="divProfileBody">
            <div class="row divrow">
              <div class="col-4">
                <label>Photo</label>
              </div>
              <div class="col-6 divEdit" title="Click Update" (click)="show('Photo')">
                <img src="../../../assets/Images/userLogo.jpg" class="elevation-2 imgProfile" alt="User Image" id="imgProfile">
                <br />
              </div>
              <div class="col-2 divEdit">
                <i class="fas fa-edit" style="color: blue;" title="Change Photo" (click)="show('Photo')"></i>
              </div>

            </div>
            <hr />
            <div class="row divrow">
              <div class="col-4">
                <label>Name</label>
              </div>
              <div class="col-6 divEdit" title="Click Update" (click)="show('Name')">
                <label id="lblName">---</label>
              </div>
              <div class="col-2 divEdit">
                <i class="fas fa-edit" style="color: blue;" title="Change Name" (click)="show('Name')"></i>
              </div>
            </div>
            <hr />
            <div class="row divrow" style="display:none">
              <div class="col-4">
                <label>Birthday</label>
              </div>
              <div class="col-6 divEdit">
                <label id="lblbirthday" title="Click Update" (click)="show('DOB')">---</label>
              </div>
              <div class="col-2 divEdit" style="display:none">
                <i class="fas fa-edit" style="color: blue;" title="Change DOB" (click)="show('DOB')"></i>
              </div>
            </div>

            <div class="row divrow" style="display:none">
              <div class="col-4">
                <label>Gender</label>
              </div>
              <div class="col-6 divEdit">
                <label id="lblGender" title="Click Update" (click)="show('Gender')">---</label>
              </div>
              <div class="col-2 divEdit" style="display:none">
                <i class="fas fa-edit" style="color: blue;" title="Change Gender" (click)="show('Gender')"></i>
              </div>
            </div>

            <div class="row divrow">
              <div class="col-4">
                <label>EmailId</label>
              </div>
              <div class="col-6 divEdit">
                <label id="lblEmailID" title="Click Update" (click)="show('EmailID')">---</label>
              </div>
              <div class="col-2 divEdit">
                <i class="fas fa-edit" style="color: blue;" title="Change EMailID" (click)="show('EmailID')"></i>
              </div>
            </div>
            <hr />
            <div class="row divrow" style="display:none">
              <div class="col-4">
                <label>Phone</label>
              </div>
              <div class="col-6 divEdit">
                <label id="lblPhone" title="Click Update" (click)="show('PhoneNo')">---</label>
              </div>
              <div class="col-2 divEdit">
                <i class="fas fa-edit" style="color: blue;" title="Change PhoneNo" (click)="show('PhoneNo')"></i>
              </div>
            </div>

            <div class="row divrow">
              <div class="col-4">
                <label>Update Security Question & Password</label>
              </div>
              <div class="col-6 divEdit" title="Click Update" (click)="show('Password')">
                <label id="lblPassword">******</label>
              </div>
              <div class="col-2 divEdit">
                <i class="fas fa-edit" style="color: blue;" title="Change Password" (click)="show('Password')"></i>
              </div>
            </div>

            <div class="row divrow" style="display:none">
              <div class="col-4">
                <label>Remember me Login</label>
              </div>
              <div class="col-6">
                <input type="checkbox" id="chkRememberMe" (click)="show('RememberMe')" />
              </div>
            </div>


            <div class="row divrow" *ngIf="multiPublist=='1'">
              <div class="col-4">

              </div>
              <div class="col-6 divEdit" title="Click Update" (click)="show('AccessChange')">
                <label id="lblAccessChange">Click to Change Current Role and Publisher</label>
              </div>

              <div class="col-2 divEdit">
                <!--<i class="fas fa-edit" style="color: blue;" title="Change Access details" (click)="show('AccessChange')"></i>-->
              </div>
            </div>
          </div>
        </div>



        <!-- The Modal -->
        <div class="modal" id="myModal" role="dialog" [style.display]="showModal ? 'block' : 'none'" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content" id="divUserProfileCT">
              <!-- Modal Header -->
              <div class="modal-header">
                <h4 class="modal-title">{{ title }}</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
              </div>

              <!-- Modal body -->
              <div class="modal-body">
                <div id="divName" class="divProfile">
                  <input type="text" id="txtLoginName" placeholder="Enter Name" class="form-control" maxlength="15" autocomplete="off" required />
                </div>
                <div id="divDOB" class="divProfile">
                  <input type="date" id="txtDOB" placeholder="Enter DOB" class="form-control" />
                </div>
                <div id="divGender" class="divProfile">
                  <select id="ddlGender" class="form-control">
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
                <div id="divEmailID" class="divProfile">
                  <input type="email" id="txtEmailID" placeholder="Enter EmailID" class="form-control" maxlength="25" autocomplete="off" (change)="emailidOnly($event)" />
                </div>
                <div id="divPhoneNo" class="divProfile">
                  <input type="text" id="txtPhoneNo" placeholder="Enter PhoneNo" class="form-control" maxlength="25" autocomplete="off" required />
                </div>
                <div id="divPassword" class="divProfile">
                  <select class="form-select" id="ddlSQList">
                    <option value="0">
                      Select Security Question
                    </option>
                    <option *ngFor="let item of SQList" value={{item.ID}}>
                      {{item.Questions}}
                    </option>
                  </select>

                  <input type="text" id="txtSQAnswer" class="form-control" placeholder="Answer" autocomplete="off" required />

                  <input type="password" id="txtOldPassword" placeholder="Old Password" class="form-control" maxlength="20" autocomplete="off" required />

                  <input type="password" id="txtNewPassword" placeholder="New Password" class="form-control" maxlength="20" autocomplete="off" required />
                </div>

                <div id="divPhoto" class="divProfile">
                  <div class="input-group" style="text-align:center;display:inline-block">
                    <img src={{this.ImageBase64}} class="elevation-2 imgEditProfile" alt="User Image">
                    <input type="file" name="file" id="imageUploadForm" style="width: 100%;" class="btn" (change)="fileChangeEvent($event)" />
                    <span>Support formats : ['png', 'jpg', 'jpeg']</span>
                  </div>
                </div>


                <div id="divAccessChange" class="divProfile">
                  <div>
                    <label>Current Publisher</label>
                  </div>
                  <div title="Click to change">
                    <select id="ddlPubList" class="form-select ddlselect" (click)="changeAccessId('PubId')">
                      <option value=0>Select</option>
                      <option *ngFor="let item of pubList" value={{item.ID}} [selected]="item.ID==currentPubId">
                        {{item.PublisherCode}}
                      </option>
                    </select>
                  </div>

                  <div>
                    <label>Current Role</label>
                  </div>
                  <div title="Click to change">
                    <select id="ddlRoleList" class="form-select ddlselect" (click)="changeAccessId('RoleId')">
                      <option value=0>Select</option>
                      <option *ngFor="let item of roleList" value={{item.RoleID}} [selected]="item.RoleID==currentRoleId">
                        {{item.RoleName}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Modal footer -->
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" (click)="UpdateProfile()">Update</button>
              </div>
            </div>
            <div id="LoadingImagePopup">
              <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
